var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quick-reply-message-viewer" }, [
    _c(
      "div",
      {
        staticClass: "sc-message--text",
        style: Object.assign(
          {},
          _vm.messageColors,
          { backgroundColor: _vm.determineColor(_vm.message) },
          _vm.extendedStyle || {}
        ),
      },
      [
        _c("div", { staticStyle: { "border-radius": "6px" } }, [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c("span", {
                staticClass: "sc-message--text-content m-1 ml-3 mr-3",
                staticStyle: { "word-break": "break-word" },
                domProps: { innerHTML: _vm._s(_vm.data.message) },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "justify-content": "end",
                "align-items": "center",
                padding: "0 0.3rem",
              },
            },
            [
              _vm.meta
                ? _c(
                    "span",
                    {
                      staticClass: "sc-message-meta-new",
                      style: { color: _vm.messageColors.color },
                    },
                    [_vm._v(_vm._s(_vm.metaShorter(_vm.meta)))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.meta2
                ? _c(
                    "span",
                    {
                      staticClass: "sc-message--meta2",
                      style: { color: _vm.messageColors.color },
                    },
                    [_vm._v(_vm._s(_vm.meta2))]
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    !_vm.clickedButton
      ? _c(
          "div",
          { staticClass: "quick-replies" },
          _vm._l(_vm.data.buttons, function (button, i) {
            return _c(
              "div",
              {
                key: button.id,
                staticClass: "quick-reply",
                on: {
                  click: function ($event) {
                    return _vm.sendButtonMessage("QUICK_REPLY", {
                      buttonId: button.id,
                      blockId: _vm.data.blockId,
                      payloadId: _vm.data.id,
                      buttonPayload: button.payload,
                    })
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "quick-reply-text",
                  domProps: { innerHTML: _vm._s(button.title) },
                }),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }